(function () {
  function initSlider(root) {
    const track = root.querySelector('.wgp__track');
    const slides = Array.from(root.querySelectorAll('.wgp__slide'));
    const btnPrev = root.querySelector('.wgp__nav--prev');
    const btnNext = root.querySelector('.wgp__nav--next');
    const loop = root.dataset.loop === '1';
    const useLightbox = root.dataset.lightbox === '1';

    let index = 0;

    function scrollToIndex(i) {
      if (!slides.length) return;
      if (i < 0) i = loop ? slides.length - 1 : 0;
      if (i >= slides.length) i = loop ? 0 : slides.length - 1;
      index = i;
      const el = slides[i];
      if (el) el.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    }

    btnPrev && btnPrev.addEventListener('click', () => scrollToIndex(index - 1));
    btnNext && btnNext.addEventListener('click', () => scrollToIndex(index + 1));

    track &&
      track.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') scrollToIndex(index - 1);
        if (e.key === 'ArrowRight') scrollToIndex(index + 1);
        if (e.key === 'Enter') slides[index] && slides[index].click();
      });

    if (useLightbox) {
      slides.forEach((a, i) => {
        a.addEventListener('click', (e) => {
          const href = a.getAttribute('href');
          if (href) e.preventDefault();
          openLightbox(
            slides.map((s) => s.getAttribute('href') || s.querySelector('img')?.src),
            i
          );
        });
      });
    }
  }

  function openLightbox(urls, startIndex) {
    const total = Array.isArray(urls) ? urls.length : 0;
    if (!total) return;

    let i = Number.isInteger(startIndex) ? startIndex : 0;
    const hasMany = total > 1;

    const overlay = document.createElement('div');
    overlay.className = 'wgp__lightbox-overlay';
    overlay.innerHTML = `
    <div class="wgp__lightbox" role="dialog" aria-modal="true">
      <span class="wgp__lb-close" aria-label="Luk">×</span>
      <img class="wgp__lb-img" alt="" />
      ${hasMany ? '<span class="wgp__lb-nav wgp__lb-prev" aria-label="Previous">‹</span>' : ''}
      ${hasMany ? '<span class="wgp__lb-nav wgp__lb-next" aria-label="Next">›</span>' : ''}
    </div>
  `;

    const img = overlay.querySelector('.wgp__lb-img');
    const btnClose = overlay.querySelector('.wgp__lb-close');
    const btnPrev = overlay.querySelector('.wgp__lb-prev');
    const btnNext = overlay.querySelector('.wgp__lb-next');

    function srcAt(idx) {
      const v = urls[idx];
      return typeof v === 'string' ? v : (v && v.url) || '';
    }

    function render() {
      const src = srcAt(i);
      if (!src) return;
      img.src = src;

      if (hasMany) {
        const p = new Image();
        p.src = srcAt((i - 1 + total) % total);
        const n = new Image();
        n.src = srcAt((i + 1) % total);
      }
    }

    function prev() {
      i = (i - 1 + total) % total;
      render();
    }
    function next() {
      i = (i + 1) % total;
      render();
    }

    function cleanupAndRemove() {
      document.removeEventListener('keydown', onKey);
      overlay.removeEventListener('transitionend', onTransitionEnd);
      if (overlay.isConnected) overlay.remove();
    }

    function close() {
      overlay.classList.remove('is-open');
      overlay.addEventListener('transitionend', onTransitionEnd, { once: true });
      setTimeout(cleanupAndRemove, 350);
    }

    function onTransitionEnd(e) {
      if (e.target === overlay) cleanupAndRemove();
    }

    function onKey(e) {
      if (!overlay.isConnected) return;
      if (e.key === 'Escape') return close();
      if (!hasMany) return;
      if (e.key === 'ArrowLeft') return prev();
      if (e.key === 'ArrowRight') return next();
    }

    btnClose && btnClose.addEventListener('click', close);
    if (hasMany) {
      btnPrev && btnPrev.addEventListener('click', prev);
      btnNext && btnNext.addEventListener('click', next);
    }

    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) close();
    });

    document.addEventListener('keydown', onKey);

    document.body.appendChild(overlay);
    requestAnimationFrame(() => overlay.classList.add('is-open'));

    render();
  }


  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.wgp__slider').forEach(initSlider);
  });
})();
